import React from 'react';

import classNames from 'classnames';

import { money } from './planHelpers';
import { colourFor, deriveCode } from './setupHelpers';

/**
 * IB-701 — a single Setup > Categories tile. Icon colour + code are auto-derived on the frontend
 * (never persisted); everything else is real category data: the name, how many procurement plan
 * items are linked, and their combined value. Clicking the tile opens the edit form.
 */
const CategoryTile = ({ category, currencySymbol, onClick }) => {
    const count = category.procurements_count ?? 0;

    return (
        <button
            type="button"
            onClick={onClick}
            className="tw-flex tw-min-h-[7.5rem] tw-w-full tw-flex-col tw-gap-3 tw-rounded-lg tw-bg-white tw-p-4 tw-text-start tw-shadow-primary tw-transition-shadow hover:tw-shadow-lg"
        >
            <div className="tw-flex tw-items-center tw-gap-3">
                <span
                    className={classNames(
                        'tw-flex tw-h-10 tw-w-10 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-lg tw-text-sm tw-font-bold',
                        colourFor(category.id),
                    )}
                >
                    {deriveCode(category.name)}
                </span>
                <div className="tw-min-w-0">
                    <div className="tw-truncate tw-text-sm tw-font-semibold tw-text-charcoal">{category.name}</div>
                    <div className="tw-text-xs tw-text-charcoal-50">{$t('{{count}} procurements', { count })}</div>
                </div>
            </div>

            <div className="tw-mt-auto tw-flex tw-items-center tw-justify-between tw-border-t tw-border-grey tw-pt-2 tw-text-xs">
                <div className="tw-text-charcoal-50">
                    {$t('Procurements')} <span className="tw-font-semibold tw-text-charcoal">{count}</span>
                </div>
                <div className="tw-text-charcoal-50">
                    {$t('Total value')}{' '}
                    <span className="tw-font-semibold tw-text-charcoal">{money(currencySymbol, category.procurements_total_value ?? 0)}</span>
                </div>
            </div>
        </button>
    );
};

export default CategoryTile;
